import React from "react";
import { withTranslation, Trans } from 'react-i18next';
import { updateRoomStatus } from './../models/room';
import Button from './../components/button';
import { Alert } from 'reactstrap';
import moment from "moment";
import Moment from "react-moment";
import { SettingsContext } from "./context";
class ScreenChecking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isUpdatingStatus: false,
      leaveTevillah: false
    }
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.tick = this.tick.bind(this);
  }

  componentDidMount() {
    this.setUpTick();
  }
  componentWillUnmount() {
    clearInterval(this.intervalID);
  }
  setUpTick() {
    this.tick();
    this.intervalID = setInterval(
      () => this.tick(),
      1000
    );
  }

  tick() {
    this.setState({
      time: moment()
    });
  }

  componentDidUpdate(prevProps) {
    if(prevProps.isLoadedSection !== this.props.isLoadedSection || prevProps.section !== this.props.section || prevProps.room.reservation.attendantInRoom !== this.props.room.reservation.attendantInRoom){
      const { room, section } = this.props;
      if(room && section && room.reservation.attendantInRoom){
        if(room.directToBor && !section.borBusyDirectToBor) {
          this.setState({leaveTevillah: true})
        } else if(!room.directToBor && !section.wetHallwayBusy && !section.borBusy) {
          this.setState({leaveTevillah: true})
        } else {
          this.setState({leaveTevillah: false})
        }
      } else {
        this.setState({leaveTevillah: false})
      }
    }
  }

  handleChangeStatus(status) {
    let roomId = this.props.room.id;

    this.setState({
      isUpdatingStatus: true,
    })

    updateRoomStatus(roomId, status)
      .then(
        result => {
          this.props.handleUpdateRoom(result);
        },
        error => {
          this.setState({
            isUpdatingStatus: false,
            error
          });
        }
      );
  }


  render() {
    const { t, room } = this.props;
    const { time, leaveTevillah, error } = this.state;
    return (
      <div className="body-right attendantInRoom">
        {error!=null
        ? <Alert color="danger">{t("An error occurred.")}</Alert>
        : null}

        <SettingsContext.Consumer>
          {({settings})=> {
            if (settings) {
              let zmanTevilah = settings.zmanTevillah.value;
              const diffInMinutes = moment.duration(moment(zmanTevilah).diff(moment(time).subtract(settings&&settings.offset&&settings.offset.value,'seconds'))).asMinutes();
              const roundedUpMinutes = Math.max(0, Math.ceil(diffInMinutes));
              const formattedZman = moment(zmanTevilah).format(t("h:mm"));  
              return (
              <>
              {moment().isBefore(moment(zmanTevilah))?
                <Alert color="warning"><Trans i18nKey={'zmanTevilahAlert'} count={roundedUpMinutes} values={{ minutes: roundedUpMinutes, zmanTime: formattedZman }}></Trans></Alert>
              :null}
              <div className="instructions">
                {t("Balanit in the room.")} {t("Choose progress to continue")}:
              </div>
              <div>
                <Button type="circle" className="mie-5" onClick={() => this.handleChangeStatus("Prep")} loading={this.state.isUpdatingStatus} text={t("Continue Prep")} />
                {room.privateRoom
                ?
                <Button className="mb-4" type="circle-big" onClick={() => this.handleChangeStatus("Dressing")} loading={this.state.isUpdatingStatus} text={t("Tevilah Completed")} />
                :
                <>
                <Button className="mb-4" type="circle-big" onClick={() => this.handleChangeStatus("ToMikvah")} disabled={!leaveTevillah} loading={this.state.isUpdatingStatus} text={t("Leave to Mikvah")} />
                {settings.reservationsUseCheckedStatus&&settings.reservationsUseCheckedStatus.value==="True"?
                  <Button type="circle" className="mis-5" onClick={() => this.handleChangeStatus("Checked")} loading={this.state.isUpdatingStatus} text={t("Checked")} />
                :
                  <Button type="circle" className="mis-5" onClick={() => this.handleChangeStatus("ReadyForMikvah")} loading={this.state.isUpdatingStatus} text={t("Ready For Tevilah")} />
                }
                </>
                }
              </div>
              </>
            )
            }
          }}
        </SettingsContext.Consumer>

      </div>
    );
  }
}

export default withTranslation()(ScreenChecking);
